const preventClick = (e2) => {
    console.log('should stop click!!!');
    e2.preventDefault();
    e2.stopPropagation();
    e2.stopImmediatePropagation();

    return false;
};

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-drag-to-scroll').forEach((e) => {
        const element = e;

        e.querySelectorAll('*').forEach((e2) => {
            const reference = e2;
            reference.draggable = false;
        });

        let pos = { top: 0, left: 0, x: 0, y: 0 };

        let isDown = false;
        let isDragged = false;

        const mouseMoveHandler = function (e2) {
            if (!isDown) return;
            isDragged = true;
            // How far mouse has been moved
            const dx = e2.clientX - pos.x;
            const dy = e2.clientY - pos.y;

            // Scroll element
            element.scrollTop = pos.top - dy;
            element.scrollLeft = pos.left - dx;
        };

        const mouseUpHandler = function () {
            isDown = false;

            element.style.removeProperty('user-select');

            const elements = element.querySelectorAll('a');

            // Prevent click any elements inside wrapper when drag was done
            // TODO: not work now :(
            if (isDragged) {
                elements.forEach((el) => {
                    el.addEventListener('click', preventClick, {
                        once: true,
                    });
                });
            }

            isDragged = false;

            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('mouseup', mouseUpHandler);
        };

        const mouseDownHandler = function (e2) {
            isDown = true;
            element.style.userSelect = 'none';

            pos = {
                left: element.scrollLeft,
                top: element.scrollTop,
                // Get current mouse position
                x: e2.clientX,
                y: e2.clientY,
            };

            document.addEventListener('mousemove', mouseMoveHandler);
            document.addEventListener('mouseup', mouseUpHandler);
        };

        element.addEventListener('mousedown', mouseDownHandler);
    });
});
